import stringPacks from 'stringPacks';

function merge(dest, src) {
  Object.keys(src).forEach(_ => {
    const val = src[_];
    if (val && typeof val === 'object') {
      merge(dest[_], val);
    } else {
      dest[_] = val;
    }
  });
}

function replaceStrings(src, replaces) {
  Object.keys(src).forEach(_ => {
    let val = src[_];
    if (val && typeof val === 'object') {
      replaceStrings(val, replaces);
    } else {
      replaces.forEach(r => val = val.replaceAll(r.old, r.new));
      src[_] = val;
    }
  });
}

const { baseLanguage } = stringPacks.config;
const { data } = stringPacks;

const strings = {};

Object.keys(data).forEach(packName => strings[packName] = data[packName][baseLanguage]);

export function initStrings(siteLanguage = null, overrides = null, replaces = null) {
  Object.keys(data).forEach(packName => {
    // override with siteLanguage strings
    if (siteLanguage && siteLanguage !== baseLanguage && typeof data[packName][siteLanguage] === 'object') {
      merge(strings[packName], data[packName][siteLanguage]);
    }

    // override with site string overrides
    if (overrides && overrides[packName] && typeof overrides[packName] === 'object') {
      merge(strings[packName], overrides[packName]);
    }

    if (replaces) {
      replaceStrings(strings[packName], replaces);
    }
  });
}

export default strings;
